import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { CloseButton, Container, Modal, Spinner } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { withRouter } from './withRouter';
import PageSEO from 'components/Utlility/PageSEO';
import { getGameSeoOverrides } from 'constants/SeoConfig';
import Help from "../components/Help";
import Analytics from "analytics";
import ReactPlayer from 'react-player';

import { getGameList, findGameById, findGameBySlug, getGamePacks, getAddons } from "constants/GameListAdapter";
import styles from './ShopSingleStyles.module.scss'
import Game from './Games/Game';
import { addToCart } from 'actions/cart';
import DotLoader from 'components/Utlility/DotLoader';
import VideoPlayer from 'components/Utlility/VideoPlayer';
import TrustBoxContainer, { TRUSTPILOT_TEMPLATES } from './TrustWidget';
import HowItWorks from 'components/Utlility/HowItWorks';

import time from 'animations/time-black.png'
import players from 'animations/minPlayers-black.png'
import clockWhite from 'animations/clock-white.png'
import playersWhite from 'animations/players-white.png'
import voiceWhite from 'animations/voice-white.png'

import age6Black from "animations/ageRatings/age-6.png";
import age8Black from "animations/ageRatings/age-8.png";
import age10Black from "animations/ageRatings/age-10.png";
import age12Black from "animations/ageRatings/age-12.png";
import age14Black from "animations/ageRatings/age-14.png";

import age6White from "animations/ageRatings/age-white-6.png";
import age8White from "animations/ageRatings/age-white-8.png";
import age10White from "animations/ageRatings/age-white-10.png";
import age12White from "animations/ageRatings/age-white-12.png";
import age14White from "animations/ageRatings/age-white-14.png";

import placeHolderDesktop from 'images/gameStorePreviews/placeholder-desktop.svg';
import loadingDesktop from 'images/gameStorePreviews/loading-desktop.svg';
import placeHolderLogo from 'images/gameLogos/placeholder-logo.svg';
import placeHolderBackground from 'images/storeBackgrounds/placeholder-background.svg';
import loadingBackground from 'images/storeBackgrounds/loading-background.svg';
import kickstarterLogo from 'images/kickstarter-logo.png';
import SaleRobot from 'images/Promotions/SaleRobot.png';
import GreenUnderline from 'images/Promotions/GreenUnderline.png';
import PricingFunctions from '../common/PricingFunctions';

import { APP_TYPES } from "constants/AppTypes";
import WebIcon from "images/icons/web-icon.png";
import FireTVIcon from "images/icons/FireTV-Icon.png";
import RokuIcon from "images/icons/Roku-Icon-v2.png";
import FireTVShopIcon from "images/icons/FireTVShop.png";
import RokuShopIcon from "images/icons/RokuShop.png";
import SmartTVShopIcon from "images/icons/SmartTVShop.png";



class ShopSingle extends Component {
    static displayName = ShopSingle.name;

    constructor(props) {
        super(props);

        this.state = {
            showHowToPlay: false,
            isLoading: true,
            price: null,
            oldPrice: null,
            showStickyBar: false
        };

        this.priceRowRef = React.createRef();
        this.observer = null;
    }

    getGame() {
        if (this.props.game) {
            return this.props.game;
        }
        return findGameBySlug(this.props.location.pathname);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.initializeGame();
        this.setupStickyObserver();
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    setupStickyObserver() {
        if (this.observer || !this.priceRowRef.current) return;
        this.observer = new IntersectionObserver(
            ([entry]) => {
                // Only show sticky bar when price row has scrolled above the viewport
                const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
                this.setState({ showStickyBar: scrolledPast });
            },
            { threshold: 0 }
        );
        this.observer.observe(this.priceRowRef.current);
    }

    componentDidUpdate(prevProps) {
        // Retry observer setup if ref wasn't ready on mount
        if (!this.observer) this.setupStickyObserver();

        const game = this.getGame();
        const prevGame = prevProps.game || findGameBySlug(prevProps.location?.pathname);
        if (!prevGame && game) {
            this.initializeGame();
            return;
        }

        const prevPricing = prevGame?.pricing;
        const currentPricing = game?.pricing;
        const prevCountryCode = prevProps.pricing?.countryCode;
        const currentCountryCode = this.props.pricing?.countryCode;

        if (prevPricing !== currentPricing || prevCountryCode !== currentCountryCode) {
            this.setState({
                price: this.getPrice(),
                oldPrice: this.getPrice(true)
            });
        }
    }

    initializeGame() {
        const game = this.getGame();
        if (game) {
            Analytics.viewContent(game.productId);

            this.setState({
                price: this.getPrice(),
                oldPrice: this.getPrice(true)
            });

            const images = [
                game.meta?.storeBackground,
                game.meta?.storeLogo,
                game.meta?.previewImages?.desktop1,
                game.meta?.previewImages?.desktop2,
            ].filter(Boolean);

            Promise.all(images.map(image => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.onload = resolve;
                    img.onerror = reject;
                    img.src = image;
                });
            })).then(() => {
                setTimeout(() => {
                    this.setState({ isLoading: false });
                }, 100);
            }).catch(() => {
                this.setState({ isLoading: false });
            });
        }
    }

    addGameToCart(game) {
        this.props.addToCart(game);
    }

    openInNewTab(url) {
        window.open(url, '_blank').focus();
    }

    getPrice(old) {
        let countryCode = this.props.pricing.countryCode;
        let game = this.getGame();

        // When a cross-region twin discount applies, use the standard price as the
        // strikethrough so the customer sees the savings.
        if (old && PricingFunctions.hasCrossRegionDiscount(game)) {
            return PricingFunctions.getGamePricing(countryCode, game, false)?.display;
        }

        let pricing = old
            ? PricingFunctions.getGamePricing(countryCode, game, true)
            : PricingFunctions.getEffectiveGamePricing(countryCode, game);
        if (old && (!pricing || !pricing.raw || pricing.raw <= 0)) {
            return null;
        }
        return pricing?.display;
    }

    closeHelpModal = () => {
        this.setState({ showHowToPlay: false });
    }

    goToAddon(g) {
        this.props.navigate(g.storeSlug)
    }

    getAdditionalStyles() {
        const game = this.getGame();
        if (game?.gameId === "playing_with_fire") {
            return { imageRendering: 'pixelated', marginBottom: '5vh' }
        }
    }

    getBackground() {
        const game = this.getGame();
        if (this.state.isLoading) return loadingBackground;
        return game?.meta?.storeBackground || placeHolderBackground;
    }

    getLogo() {
        const game = this.getGame();
        if (this.state.isLoading) return placeHolderLogo;
        return game?.meta?.storeLogo || placeHolderLogo;
    }

    getPreviewImage(type) {
        const game = this.getGame();
        const previewImages = game?.meta?.previewImages;
        if (this.state.isLoading) return loadingDesktop;
        const image = previewImages?.[type];
        if (image) return image;
        return placeHolderDesktop;
    }

    isDev() {
        return !process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === 'development';
    }

    getAgeIcon(white) {
        const game = this.getGame();
        if (white) {
            switch (game?.gameInfo?.minAge) {
                case 6: return age6White;
                case 8: return age8White;
                case 10: return age10White;
                case 12: return age12White;
                case 14: return age14White;
                default: return age8White;
            }
        }
        switch (game?.gameInfo?.minAge) {
            case 6: return age6Black;
            case 8: return age8Black;
            case 10: return age10Black;
            case 12: return age12Black;
            case 14: return age14Black;
            default: return age8Black;
        }
    }

    getSupportedPlatforms() {
        const game = this.getGame();
        if (!game) return;

        let platforms = [];
        for (let i = 0; i < game.supportedPlatforms.length; i++) {
            let platform = game.supportedPlatforms[i];
            let img = null;
            let link = null;

            switch (platform) {
                case APP_TYPES.WEB:
                    img = WebIcon;
                    break;
                case APP_TYPES.FIRE_TV:
                    img = FireTVShopIcon;
                    link = "https://www.amazon.co.uk/Game-City-Game-City/dp/B0FCYQ3QY7/ref=sr_1_6?crid=1HYZ8KROZPE3Q&dib=eyJ2IjoiMSJ9.8FmPt9aRPWTU9EIjS4v9rBc1OzkR5g7FwwI6Bts_C4nD1Hos0s_FKTAEzgkEW5MWoFy-Z7AN9cDeW70SMLQ_JiDh_WU6x3PrH2CxLSmUbHPBgWA-UszU3foPJtC0pK2aseieTBMCVzwS2Ez2UeKVh-cjY5p_0E_fqYRG4qAfYscIMoOKn-1jKWxS-RpyIw9lgpr8JUMQaSZyq_COX2MO3SKsoyShTzZONoktuJoNTJkVJ2fcS4g_iGAU5y-Qy8g45K9Cah0IEH2EkelWFkIHmt6SKaU8FDTL3FTD90uElsk.DYEAaB96KVfdhfMuXvjklBo42TKSgftMh4AT_oE44mU&dib_tag=se&keywords=Game+City&qid=1756198594&sprefix=game+city%2Caps%2C104&sr=8-6";
                    break;
                case APP_TYPES.ROKU:
                    img = RokuShopIcon;
                    link = "https://channelstore.roku.com/en-gb/details/f40f6c4e12bfb9b619aa4530404178ea:bf00789f9ba54a68d7fc648d46ddbfc5/game-city-party-games-on-tv";
                    break;
                default:
                    break;
            }

            if (img != null) {
                if (link != null) {
                    platforms.push(
                        <div className={styles.platform} key={platform}>
                            <a href={link} target="_blank" rel="noopener noreferrer">
                                <img src={img} alt={platform} />
                            </a>
                        </div>
                    )
                } else {
                    platforms.push(
                        <div className={styles.platform} key={platform}>
                            <img src={img} alt={platform} />
                        </div>
                    )
                }
            }
        }

        return platforms;
    }

    renderVideoSection(game) {
        if (game.meta?.trailerVideoUrl) {
            return (
                <div className={styles.videoSection}>
                    <VideoPlayer key={game.meta.trailerVideoUrl} src={game.meta.trailerVideoUrl} autoPlay={true} loop poster={game.meta?.storeCard || game.meta?.previewImages?.desktop1} splashBg={game.meta?.storeBackground} splashLogo={game.meta?.storeLogo} />
                </div>
            );
        }

        if (game.meta?.trailerUrl) {
            return (
                <div className={styles.videoSection}>
                    <div className={styles.reactPlayerWrapper}>
                        <ReactPlayer
                            url={game.meta.trailerUrl}
                            controls
                            width='100%'
                            height='100%'
                        />
                    </div>
                </div>
            );
        }

        // No video/trailer — logo is shown instead, skip preview fallback
        return null;
    }

    renderInfoCard(game) {
        return (
            <div className={styles.infoCard}>
                {/* Game name */}
                <h1 className={styles.gameName}>{game.name}</h1>

                {/* Tags */}
                <div className={styles.tagsRow}>
                    {game.gameShow && <span>TV Quiz Show</span>}
                    {game.partyGame && <span>Party Game</span>}
                    <span>Play on your TV</span>
                </div>

                {/* Price + Add to cart — inline row, robot on right for mobile */}
                <div className={styles.priceCartRow} ref={this.priceRowRef}>
                    <div className={`${styles.priceCartInner} ${!this.state.oldPrice ? styles.noSale : ''}`}>
                        <div className={styles.priceContainer}>
                            {this.state.oldPrice && (
                                <span className={styles.oldPrice}>{this.state.oldPrice}</span>
                            )}
                            <span className={styles.currentPrice}>
                                {this.state.price || <DotLoader size="medium" variant="dark" />}
                            </span>
                        </div>
                        {game.kickstarter ? (
                            <button className={styles.kickstarterBtn} onClick={() => this.openInNewTab("https://www.kickstarter.com/projects/1169339123/1485717407?ref=2maee1")}>
                                FIND OUT MORE ON
                                <img src={kickstarterLogo} className={styles.kickstarterLogo} alt="Kickstarter" />
                            </button>
                        ) : (
                            <button className={styles.addToCartBtn} onClick={() => this.addGameToCart(game)}>
                                Add To Cart
                            </button>
                        )}
                    </div>
                    {this.state.oldPrice && <img src={SaleRobot} className={`${styles.saleRobot} ${styles.saleRobotMobile}`} alt="" />}
                </div>

                {/* Companion discount card — owner or buy-both */}
                {PricingFunctions.hasCrossRegionDiscount(game) && (() => {
                    const discount = PricingFunctions.getCrossRegionDiscount(game);
                    const offer = PricingFunctions.getCompanionOffer(game);
                    return (
                        <div className={styles.companionOfferCard}>
                            {offer?.companionStoreCard && (
                                <img src={offer.companionStoreCard} alt={discount.ownedPackName} className={styles.companionOfferImage} />
                            )}
                            <div className={styles.companionOfferText}>
                                <span className={styles.companionOfferTitle}>{discount.percent}% off — you own {discount.ownedPackName}</span>
                                <span className={styles.companionOfferSub}>Your discount is applied automatically at checkout</span>
                            </div>
                        </div>
                    );
                })()}
                {PricingFunctions.shouldShowCompanionOffer(game) && (() => {
                    const offer = PricingFunctions.getCompanionOffer(game);
                    return (
                        <div className={styles.companionOfferCard}>
                            {offer.companionStoreCard && (
                                <img src={offer.companionStoreCard} alt={offer.companionName} className={styles.companionOfferImage} />
                            )}
                            <div className={styles.companionOfferText}>
                                <span className={styles.companionOfferTitle}>Buy both &amp; save {offer.discountPercent}%</span>
                                <span className={styles.companionOfferSub}>Add <a href={offer.companionStoreSlug} className={styles.companionOfferLink} onClick={(e) => { e.preventDefault(); this.props.navigate(offer.companionStoreSlug); }}>{offer.companionName}</a> and get it discounted</span>
                            </div>
                            <button className={styles.companionOfferBtn} onClick={(e) => {
                                e.stopPropagation();
                                const companionGame = findGameBySlug(offer.companionStoreSlug);
                                if (companionGame) {
                                    this.addGameToCart(game);
                                    this.addGameToCart(companionGame);
                                }
                            }}>Buy Both</button>
                        </div>
                    );
                })()}

                {/* Purple container: Game info bar — horizontal layout */}
                {!game.kickstarter && (
                    <div className={styles.gameInfoBar}>
                        <div className={styles.infoItem}>
                            <div className={styles.infoIconCircle}><img src={clockWhite} alt="" /></div>
                            <span className={styles.infoLabel}>Play Time:</span>
                            <span className={styles.infoValue}>{game.gameInfo?.avgRoundLengthText}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <div className={styles.infoIconCircle}><img src={playersWhite} alt="" /></div>
                            <span className={styles.infoLabel}>Players:</span>
                            <span className={styles.infoValue}>{game.gameInfo?.minPlayers}-{game.gameInfo?.maxPlayers ?? 8}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <div className={styles.infoIconCircle}><img src={this.getAgeIcon(true)} alt="" /></div>
                            <span className={styles.infoLabel}>Age:</span>
                            <span className={styles.infoValue}>{game.gameInfo?.minAge}+</span>
                        </div>
                        {game.gameInfo?.voiceEnabled && (
                            <div className={styles.infoItem}>
                                <div className={styles.infoIconCircle}><img src={voiceWhite} alt="" /></div>
                                <span className={styles.infoLabel}>
                                    Voice activation{' '}<br className={styles.voiceBreak} />available
                                </span>
                            </div>
                        )}
                    </div>
                )}

                {/* About section */}
                <div className={styles.aboutSection}>
                    <div className={styles.aboutHeadingWrap}>
                        <h3 className={styles.aboutHeading}>ABOUT</h3>
                        <img src={GreenUnderline} className={styles.greenUnderline} alt="" />
                    </div>
                    <p className={styles.aboutLead}>{game.description}</p>
                    <ul className={styles.gameDescription}>
                        {game.gameInfo?.descriptions?.map((desc, i) => (
                            <li key={i}>
                                <p className={styles.descriptionHeader}>
                                    {desc.header?.toLowerCase().replace(/(?:^|\s)\w/g, c => c.toUpperCase())}
                                </p>
                                <p className={styles.descriptionBody}>{desc.body}</p>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Supported Platforms */}
                <hr className={styles.divider} />
                <p className={styles.platformsHeading}>Supported Platforms</p>
                <div className={styles.platformsList}>
                    {this.getSupportedPlatforms()}
                </div>

                {/* Licence */}
                {game.licence && (
                    <>
                        <hr className={styles.divider} />
                        <div className={styles.gameLicence}>{game.licence}</div>
                    </>
                )}

                {/* Included In (game packs) */}
                {getGamePacks().find((x) => x.subGames?.includes(game.gameId)) && (
                    <div className={styles.addonsSection}>
                        <p className={styles.addonsHeading}>Included In</p>
                        <div className={styles.addonsList}>
                            {getGamePacks().filter((x) => x.status === "enabled" && x.subGames?.includes(game.gameId)).map((g) => (
                                <div className={styles.addonItem} onClick={() => this.goToAddon(g)} key={g.gameId}>
                                    <img src={g.meta?.storeTinyCard} alt={g.name} className={styles.tinyCard} />
                                    <div className={styles.details}>
                                        <div>
                                            <p className={styles.addonHeader}>{g.name}</p>
                                            <p className={styles.addonPrice}>{PricingFunctions.getGamePricing(this.props.pricing.countryCode, g)?.display}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Add-ons */}
                {(game.addonIds?.length > 0) && (
                    <div className={styles.addonsSection}>
                        <p className={styles.addonsHeading}>Add-ons</p>
                        <div className={styles.addonsList}>
                            {getAddons().filter((x) => game.addonIds?.includes(x.gameId)).map((g) => (
                                <div className={styles.addonItem} onClick={() => this.goToAddon(g)} key={g.gameId}>
                                    <img src={g.meta?.storeTinyCard} alt={g.name} className={styles.tinyCard} />
                                    <div className={styles.details}>
                                        <div>
                                            <p className={styles.addonHeader}>{g.name}</p>
                                            <p className={styles.addonPrice}>{PricingFunctions.getGamePricing(this.props.pricing.countryCode, g)?.display}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const game = this.getGame();

        if (!game) {
            return (
                <div className={styles.pageShopSingle} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
                    <DotLoader size="large" variant="dark" />
                </div>
            );
        }

        return (
            <React.Fragment>
                {(() => {
                    const seoOverrides = getGameSeoOverrides(game.storeSlug);
                    const title = seoOverrides?.title || `Play ${game.name} on Your TV | Game.city`;
                    const description = seoOverrides?.description || game.description;
                    const canonical = `https://game.city${game.storeSlug}`;
                    const ogImage = game.meta?.storeCard || game.meta?.previewImages?.desktop1;
                    return <PageSEO title={title} description={description} canonical={canonical} robots="index, follow" ogType="product" ogImage={ogImage} />;
                })()}

                {/* Product schema.org JSON-LD */}
                {this.state.price && (
                    <Helmet>
                        <script type="application/ld+json">{JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "Product",
                            "name": game.name,
                            "description": game.description,
                            "image": game.meta?.storeCard || game.meta?.storeLogo,
                            "brand": { "@type": "Brand", "name": "Game.city" },
                            "offers": {
                                "@type": "Offer",
                                "price": PricingFunctions.getGamePricing(this.props.pricing.countryCode, game)?.raw || 0,
                                "priceCurrency": PricingFunctions.getCurrency(this.props.pricing.countryCode),
                                "availability": "https://schema.org/InStock",
                                "url": `https://game.city${game.storeSlug}`
                            }
                        })}</script>
                    </Helmet>
                )}

                <div className={styles.pageShopSingle}>
                    {/* Full-page cloud/stars background (same as rest of site) */}
                    <div className={styles.cloudBG} />

                    {/* Game background overlay at top — fades into the cloud BG */}
                    <div className={styles.gameBgLayer} style={{
                        backgroundImage: `url(${this.getBackground()})`,
                        backgroundColor: game.meta?.storeBackgroundColour || '#2a2a2a'
                    }} />

                    {/* Dev banner */}
                    {game.status === "hidden" && this.isDev() && (
                        <div className={styles.devBanner}>
                            DEV ONLY - This product is hidden from the store (purchasable via direct link only)
                        </div>
                    )}

                    {/* SEO heading (visible but small) */}
                    <h1 className={styles.seoHeading}>{getGameSeoOverrides(game.storeSlug)?.h1 || `Play ${game.name} on Your TV`}</h1>

                    {/* Main content stack */}
                    <div className={styles.contentStack}>
                        {/* Back to shop breadcrumb */}
                        <div className={styles.backNav} onClick={() => this.props.navigate('/shop')}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
                            <span>Back to Shop</span>
                        </div>

                        {/* Logo — hidden when video/trailer available (splash overlay replaces it) */}
                        <div className={`${styles.gameLogo} ${(game.meta?.trailerVideoUrl || game.meta?.trailerUrl) ? styles.logoHidden : ''}`}>
                            <img src={this.getLogo()} style={this.getAdditionalStyles()} className={`${styles.storeLogo} ${game.meta?.storeLogo2 && styles.hasSecond} ${this.state.isLoading ? styles.logoLoading : ''}`} alt={`${game.name} Logo`} />
                            {game.meta?.storeLogo2 && <img src={game.meta?.storeLogo2} className={styles.storeLogo2} alt={`${game.name} logo`} />}
                        </div>

                        {/* Video / Trailer / Image */}
                        {this.renderVideoSection(game)}

                        {/* White info card + robot wrapper */}
                        <div className={styles.infoCardWrapper}>
                            {this.state.oldPrice && <img src={SaleRobot} className={`${styles.saleRobot} ${styles.saleRobotDesktop}`} alt="" />}
                            {this.renderInfoCard(game)}
                        </div>
                    </div>

                    {/* Lower sections */}
                    <div className={styles.lowerSections}>

                        {/* How It Works */}
                        <HowItWorks />

                        {/* More Games */}
                        <div className={`text-center ${styles.moreGamesSection}`}>
                            <h2>More Games You'll Like</h2>
                            <Container>
                                <div className="row justify-content-center">
                                    {getGameList().filter((x) => x.status === "enabled" && game.gameUpsellIds?.includes(x.gameId)).map(g =>
                                        <div className='col-md-6 col-lg-4 text-center' key={g.gameId}><Game showAddToCart={true} game={g} /></div>
                                    )}
                                </div>
                            </Container>
                        </div>

                        {/* Reviews */}
                        <section className={styles.reviewsSection}>
                            <div className="container">
                                <TrustBoxContainer
                                    templateId={TRUSTPILOT_TEMPLATES.CAROUSEL}
                                    height="240px"
                                    width="100%"
                                    theme="dark"
                                    stars="5"
                                />
                            </div>
                        </section>
                    </div>

                </div>

                {/* Sticky Add to Cart bar — slides down from top */}
                {!game.kickstarter && (
                    <div className={`${styles.stickyBar} ${this.state.showStickyBar ? styles.stickyBarVisible : ''}`}>
                        <div className={styles.stickyBarInner}>
                            <div className={styles.stickyBarInfo}>
                                <img src={game.meta?.storeLogo} className={styles.stickyBarLogo} alt="" />
                                <span className={styles.stickyBarName}>{game.name}</span>
                            </div>
                            <div className={styles.stickyBarRight}>
                                <div className={styles.stickyBarPriceBox}>
                                    {this.state.oldPrice && (
                                        <span className={styles.stickyBarOldPrice}>{this.state.oldPrice}</span>
                                    )}
                                    <span className={styles.stickyBarPrice}>{this.state.price}</span>
                                </div>
                                <button className={styles.stickyBarBtn} onClick={() => this.addGameToCart(game)}>
                                    Add To Cart
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* How To Play Modal */}
                <Modal show={this.state.showHowToPlay} onHide={this.closeHelpModal} contentClassName={styles.rounded}>
                    <CloseButton style={{ position: "absolute" }} onClick={this.closeHelpModal} />
                    <Help />
                </Modal>
            </React.Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pricing: state.pricing
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (game) => {
            dispatch(addToCart(game))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShopSingle));
